import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IonicModule } from '@ionic/angular';
import { SharedComponentsModule } from 'apps/idl/src/components/sharedComponents.module';
import { RecentsModule } from 'apps/idl/src/modules/preferences/recents/recents.module';
import { ActesService } from './actes.service';
import { ConcatActesPipe, C_RESUME_ACTE__MODE } from './concat-actes.pipe';
import { IntervenantNamePipe } from './intervenant-name.pipe';
import { EResumeActeMode } from './model/EResumeActeMode';
import { FavoritesModule } from '../preferences/favorites/favorites.module';
import { PipeModule } from '../../pipes';

const components: Type<any>[] = [
	ConcatActesPipe,
	IntervenantNamePipe,
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		IonicModule,
		RecentsModule.forRoot({ limit: 3 }),
		FavoritesModule,
		FormsModule,
		PipeModule,
		MatTooltipModule,
		MatFormFieldModule,
		MatInputModule,
		MatChipsModule,
		MatExpansionModule,
		MatSelectModule,
		SharedComponentsModule
	],
	providers: [
		ConcatActesPipe,
		ActesService,
		DecimalPipe,
		IntervenantNamePipe,
		{ provide: C_RESUME_ACTE__MODE, useValue: EResumeActeMode.label }
	]
})
export class ActesModule { }